import { DatePipe, JsonPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, effect, inject, input, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { CartComponentStore, SavedPartListComponentStore } from 'cart-data';
import { DialogService } from 'common-ui';
import { IntegerFormControl, NumberFormRangeStrategy } from 'forms-data';
import { SectionComponent } from 'page-layouts-ui';
import { CartStepperInputComponent, SavedPartListResultsComponent } from '../../item';

@Component({
  selector: 'ideal-saved-parts-list-details',
  imports: [
    SavedPartListResultsComponent,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    DatePipe,
    SectionComponent,
    JsonPipe,
    CartStepperInputComponent,
  ],
  templateUrl: './saved-parts-list-details.component.html',
  styleUrl: './saved-parts-list-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [SavedPartListComponentStore],
})
export class SavedPartsListDetailsComponent {
  private readonly _cartStore = inject(CartComponentStore);
  private readonly _dialogService = inject(DialogService);
  private readonly _savedStore = inject(SavedPartListComponentStore);
  public readonly savedPartListId = input.required<number>();
  public readonly listType = input.required<1 | 2>();
  protected readonly savedPartList = this._savedStore.cart;

  protected readonly title = computed(() => `Saved Part List - ${this.savedPartList()?.name ?? ''}`);

  protected readonly multiple = signal(1);

  protected readonly control = new IntegerFormControl(1, {
    min: 1,
    max: 999_999_999,
    step: 1,
    rangeStrategy: NumberFormRangeStrategy.Restrict,
  });

  constructor() {
    effect(() => {
      this._savedStore.selectCartById(`${this.listType()}|${this.savedPartListId()}`);
    });
  }

  protected addToCart(): void {
    const cartItems = this._savedStore.cartItems();
    const multiple = this.multiple();

    cartItems.forEach((item) => {
      const currentQuantity = this._cartStore.cartItems().find((cartItem) => cartItem.id.equals(item.id))?.quantity ?? 0;
      const newQuantity = currentQuantity + multiple;
      this._cartStore.updateItemQuantity(item.id, newQuantity);
    });
    this._dialogService.notice(`Added items to cart`);
  }
}
